(function () {
	'use strict';

	var MODAL_SELECTOR = '[data-zoom-modal]';
	var SLIDER_SELECTOR = '[data-zoom-slider]';
	var SLIDE_SELECTOR = '[data-zoom-slide]';
	var THUMB_SELECTOR = '[data-zoom-thumb]';
	var MEDIA_SELECTOR = '[data-zoom-media]';
	var OPEN_CLASS = 'product-zoom-open';
	var MOBILE_GALLERY_QUERY = '(max-width: 767px)';

	function getSwiper(modal) {
		var slider = modal && modal.querySelector(SLIDER_SELECTOR);

		return slider && slider.swiper ? slider.swiper : null;
	}

	function isMobileGallery() {
		return window.matchMedia(MOBILE_GALLERY_QUERY).matches;
	}

	function setMobileSwipe(swiper) {
		if (!swiper) {
			return;
		}

		var shouldAllowTouch = isMobileGallery();

		swiper.allowTouchMove = shouldAllowTouch;

		if (swiper.params) {
			swiper.params.allowTouchMove = shouldAllowTouch;
		}

		if (typeof swiper.update === 'function') {
			swiper.update();
		}
	}

	function setActiveThumb(modal, mediaId) {
		if (!modal || !mediaId) {
			return;
		}

		modal.querySelectorAll(THUMB_SELECTOR).forEach(function (thumb) {
			thumb.classList.toggle('is-active', thumb.dataset.zoomThumb === String(mediaId));
		});
	}

	function toggleDocumentScrollLock() {
		var hasOpenModal = !!document.querySelector(MODAL_SELECTOR + '.is-active, ' + MODAL_SELECTOR + '.is-open');

		document.documentElement.classList.toggle(OPEN_CLASS, hasOpenModal);
		document.body.classList.toggle(OPEN_CLASS, hasOpenModal);
	}

	function clamp(value, min, max) {
		return Math.max(Math.min(value, max), min);
	}

	function normalizeWheelDelta(delta, deltaMode) {
		if (deltaMode === 1) {
			return delta * 16;
		}

		if (deltaMode === 2) {
			return delta * window.innerHeight;
		}

		return delta;
	}

	function getTranslate(element) {
		var transform = window.getComputedStyle(element).transform;

		if (!transform || transform === 'none') {
			return {
				x: 0,
				y: 0
			};
		}

		var matrix = new window.DOMMatrixReadOnly(transform);

		return {
			x: matrix.m41,
			y: matrix.m42
		};
	}

	function panZoomedSlide(event, modal) {
		var swiper = getSwiper(modal);
		var activeSlide = swiper && swiper.slides && swiper.slides[swiper.activeIndex];

		if (!activeSlide) {
			return;
		}

		event.preventDefault();

		if (!activeSlide.classList.contains('swiper-slide-zoomed')) {
			return;
		}

		var zoomContainer = activeSlide.querySelector('.swiper-zoom-container');
		var zoomTarget = zoomContainer && zoomContainer.querySelector('.swiper-zoom-target, picture, img, svg, canvas');
		var zoomScale = swiper.zoom && swiper.zoom.scale ? swiper.zoom.scale : 1;

		if (!zoomContainer || !zoomTarget || zoomScale <= 1) {
			return;
		}

		var current = getTranslate(zoomContainer);
		var slideWidth = activeSlide.offsetWidth || window.innerWidth;
		var slideHeight = activeSlide.offsetHeight || window.innerHeight;
		var targetWidth = zoomTarget.offsetWidth || zoomTarget.clientWidth || slideWidth;
		var targetHeight = zoomTarget.offsetHeight || zoomTarget.clientHeight || slideHeight;
		var scaledWidth = targetWidth * zoomScale;
		var scaledHeight = targetHeight * zoomScale;
		var minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
		var maxX = -minX;
		var minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
		var maxY = -minY;
		var deltaX = normalizeWheelDelta(event.deltaX, event.deltaMode);
		var deltaY = normalizeWheelDelta(event.deltaY, event.deltaMode);
		var nextX = clamp(current.x - deltaX, minX, maxX);
		var nextY = clamp(current.y - deltaY, minY, maxY);

		zoomContainer.style.transitionDuration = '0ms';
		zoomContainer.style.transform = 'translate3d(' + nextX + 'px, ' + nextY + 'px, 0)';
		event.stopPropagation();
	}

	function findSlideIndex(modal, mediaId) {
		var slides = Array.prototype.slice.call(modal.querySelectorAll(SLIDE_SELECTOR));

		return slides.findIndex(function (slide) {
			return slide.dataset.zoomSlide === String(mediaId);
		});
	}

	function slideToMedia(modal, mediaId, attempt) {
		var nextAttempt = attempt || 0;

		if (!modal || !mediaId) {
			return;
		}

		var index = findSlideIndex(modal, mediaId);
		var swiper = getSwiper(modal);

		if (index < 0) {
			return;
		}

		if (!swiper) {
			if (nextAttempt < 50) {
				window.setTimeout(function () {
					slideToMedia(modal, mediaId, nextAttempt + 1);
				}, 80);
			}

			return;
		}

		if (swiper.zoom && typeof swiper.zoom.out === 'function') {
			swiper.zoom.out();
		}

		setMobileSwipe(swiper);
		swiper.slideTo(index, 0);
		setActiveThumb(modal, mediaId);
	}

	function resetZoom(modal, attempt) {
		var nextAttempt = attempt || 0;
		var swiper = getSwiper(modal);

		if (!modal) {
			return;
		}

		if (!swiper) {
			if (nextAttempt < 50) {
				window.setTimeout(function () {
					resetZoom(modal, nextAttempt + 1);
				}, 80);
			}

			return;
		}

		if (swiper.zoom && typeof swiper.zoom.out === 'function') {
			swiper.zoom.out();
		}
	}

	function bindModal(modal) {
		var attempts = 0;
		var mediaQuery = window.matchMedia(MOBILE_GALLERY_QUERY);

		if (!modal || modal.dataset.zoomGalleryBound === 'true') {
			return;
		}

		modal.dataset.zoomGalleryBound = 'true';
		modal.addEventListener('wheel', function (event) {
			panZoomedSlide(event, modal);
		}, { passive: false });

		new MutationObserver(toggleDocumentScrollLock).observe(modal, {
			attributes: true,
			attributeFilter: ['class']
		});

		function waitForSwiper() {
			var swiper = getSwiper(modal);

			attempts += 1;

			if (!swiper) {
				if (attempts < 80) {
					window.setTimeout(waitForSwiper, 100);
				}

				return;
			}

			setMobileSwipe(swiper);

			swiper.on('slideChange', function () {
				var activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];

				if (activeSlide && activeSlide.dataset.zoomSlide) {
					setActiveThumb(modal, activeSlide.dataset.zoomSlide);
				}
			});

			var onMediaQueryChange = function () {
				setMobileSwipe(swiper);
			};

			if (typeof mediaQuery.addEventListener === 'function') {
				mediaQuery.addEventListener('change', onMediaQueryChange);
			} else if (typeof mediaQuery.addListener === 'function') {
				mediaQuery.addListener(onMediaQueryChange);
			}
		}

		waitForSwiper();
		toggleDocumentScrollLock();
	}

	function bindAll() {
		document.querySelectorAll(MODAL_SELECTOR).forEach(bindModal);
	}

	document.addEventListener('click', function (event) {
		var thumb = event.target.closest(THUMB_SELECTOR);

		if (thumb) {
			event.preventDefault();
			event.stopPropagation();
			slideToMedia(thumb.closest(MODAL_SELECTOR), thumb.dataset.zoomThumb);
			return;
		}

		var media = event.target.closest(MEDIA_SELECTOR);

		if (media) {
			var container = media.closest('[data-zoom-container]');
			var modal = container && container.querySelector(MODAL_SELECTOR);

			if (modal) {
				window.setTimeout(function () {
					setActiveThumb(modal, media.dataset.zoomMedia);
					resetZoom(modal);
				}, 0);
			}
		}
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bindAll);
	} else {
		bindAll();
	}

	document.addEventListener('shopify:section:load', bindAll);
})();
